// extracted by mini-css-extract-plugin
module.exports = {"bb-soundcloud":"bb-soundcloud__JtZNo"};